import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "masking"
    }}>{`Masking`}</h1>
    <p>{`Use masks to control image manipulation in Firefly APIs`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "600px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "60.62500000000001%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/5530d/masking-concept-original.webp 320w", "/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/411c4/masking-concept-original.webp 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/8980b/masking-concept-original.jpg 320w", "/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/e224a/masking-concept-original.jpg 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "type": "image/jpeg"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/e224a/masking-concept-original.jpg",
                  "alt": "a picture of a person with a green scenic background",
                  "title": "a picture of a person with a green scenic background",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`Image`}</p></td>
          <td parentName="tr" {...{
            "align": null
          }}><span parentName="td" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "600px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "60.62500000000001%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "display": "block",
                  "transition": "opacity 0.5s 0.5s",
                  "pointerEvents": "none"
                }
              }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/5530d/masking-concept-mask.webp 320w", "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/411c4/masking-concept-mask.webp 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "type": "image/webp"
                }}></source>{`
          `}<source parentName="picture" {...{
                  "srcSet": ["/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/8980b/masking-concept-mask.jpg 320w", "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/e224a/masking-concept-mask.jpg 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "type": "image/jpeg"
                }}></source>{`
          `}<img parentName="picture" {...{
                  "className": "gatsby-resp-image-image",
                  "src": "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/e224a/masking-concept-mask.jpg",
                  "alt": "a mask of a person shape with a white background",
                  "title": "a mask of a person shape with a white background",
                  "loading": "lazy",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "opacity": "0",
                    "transition": "opacity 0.5s",
                    "color": "inherit",
                    "boxShadow": "inset 0px 0px 0px 400px none",
                    "top": "0",
                    "left": "0"
                  }
                }}></img>{`
        `}</picture>{`
    `}</span>{` `}<p style={{
              "textAlign": "center"
            }}>{`Image Mask`}</p></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Masking allows you to isolate specific parts of an image for modifications while leaving other areas unchanged. This process is essential in scenarios where you want precise control over which portions of an image are edited.`}</p>
    <p>{`In the case of Firefly APIs, masking can help with tasks such as filling images, expanding images, and compositing images.`}</p>
    <h2 {...{
      "id": "mask"
    }}>{`Mask`}</h2>
    <p>{`A mask is a grayscale overlay applied to an image. It determines which parts of the image are unaffected by edits and which parts are open to edits. Here's how it works:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Black`}</strong>{` areas are `}<strong parentName="li">{`protected`}</strong>{`. No requested edits will apply to these regions.`}</li>
      <li parentName="ul"><strong parentName="li">{`White`}</strong>{` areas are `}<strong parentName="li">{`exposed`}</strong>{`. Requested edits will apply only to these regions.`}</li>
    </ul>
    <h3 {...{
      "id": "example"
    }}>{`Example`}</h3>
    <h4 {...{
      "id": "original-image"
    }}>{`Original Image`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.62500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/5530d/masking-concept-original.webp 320w", "/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/411c4/masking-concept-original.webp 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/8980b/masking-concept-original.jpg 320w", "/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/e224a/masking-concept-original.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/firefly-services/docs/static/f6ab369b65f040f85e72a3c792f11cc9/e224a/masking-concept-original.jpg",
            "alt": "a picture of a person with a green scenic background",
            "title": "a picture of a person with a green scenic background",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h4 {...{
      "id": "mask-1"
    }}>{`Mask`}</h4>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.62500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/5530d/masking-concept-mask.webp 320w", "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/411c4/masking-concept-mask.webp 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/8980b/masking-concept-mask.jpg 320w", "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/e224a/masking-concept-mask.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/e224a/masking-concept-mask.jpg",
            "alt": "a mask of a person shape with a white background",
            "title": "a mask of a person shape with a white background",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`In the example above, we can see that the white background exposes the park scenery to any requested edits.`}</p>
    <p>{`Think of the white areas as beams from flashlights illuminating the parts of the image where edits can occur, while the black areas stay in shadow, shielded from any alterations.`}</p>
    <h2 {...{
      "id": "inverted-mask"
    }}>{`Inverted Mask`}</h2>
    <p>{`Inverting a mask switches its black and white areas:`}</p>
    <ul>
      <li parentName="ul">{`Previously `}<strong parentName="li">{`black`}</strong>{` areas become `}<strong parentName="li">{`white`}</strong>{` and therefore are now `}<strong parentName="li">{`exposed`}</strong>{` to edits.`}</li>
      <li parentName="ul">{`Previously `}<strong parentName="li">{`white`}</strong>{` areas become `}<strong parentName="li">{`black`}</strong>{` and therefore are now `}<strong parentName="li">{`protected`}</strong>{` from edits.`}</li>
    </ul>
    <h3 {...{
      "id": "example-1"
    }}>{`Example`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.62500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/5530d/masking-concept-mask.webp 320w", "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/411c4/masking-concept-mask.webp 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/8980b/masking-concept-mask.jpg 320w", "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/e224a/masking-concept-mask.jpg 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/firefly-services/docs/static/2e6e3323a386e7baebcb80f45fb2b526/e224a/masking-concept-mask.jpg",
            "alt": "a mask of a person shape with a white background",
            "title": "a mask of a person shape with a white background",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`The original mask above only allows edits to the park scenery. No edits will apply to the person.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.62500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/0b0f556bf4b40737f8159d177b05a115/5530d/masking-concept-inverted.webp 320w", "/firefly-services/docs/static/0b0f556bf4b40737f8159d177b05a115/411c4/masking-concept-inverted.webp 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/firefly-services/docs/static/0b0f556bf4b40737f8159d177b05a115/dd4a7/masking-concept-inverted.png 320w", "/firefly-services/docs/static/0b0f556bf4b40737f8159d177b05a115/dface/masking-concept-inverted.png 600w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/firefly-services/docs/static/0b0f556bf4b40737f8159d177b05a115/dface/masking-concept-inverted.png",
            "alt": "an inverted mask of a person shape with a black background",
            "title": "an inverted mask of a person shape with a black background",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`The inverted mask above only allows edits to the person. No edits will apply to the park scenery.`}</p>
    <p>{`Inverting a mask is a quick way to reverse the selection of editable areas. This technique offers flexibility, allowing you to focus on different parts of the image as needed during the editing process.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      